import React from 'react'

export const isMobileView = (breakpoint = 768) => {
  if (typeof window === 'undefined') {
    return false
  }

  return window.innerWidth <= breakpoint
}

export const useIsMobileView = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = React.useState(isMobileView(breakpoint))

  React.useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(isMobileView(breakpoint))
    }

    checkIfMobile()
    window.addEventListener('resize', checkIfMobile)
    return () => window.removeEventListener('resize', checkIfMobile)
  }, [breakpoint])

  return isMobile
}

export default isMobileView
